import React from 'react';
import { FormControl, Checkbox, InputGroup } from 'react-bootstrap';
import { Field } from 'react-final-form';

const InputField = ({ input, ...rest }) => <FormControl {...input} {...rest} />;

const DollarField = ({ input, ...rest }) => (
  <InputGroup>
    <InputGroup.Addon>$</InputGroup.Addon>
    <FormControl bsSize="small" {...input} {...rest} />
  </InputGroup>
);

const CheckboxField = ({ input, ...rest }) => (
  <Checkbox {...input} {...rest}>
    {rest.title}
  </Checkbox>
);

export default function ScheduleEFNonPriorityCreditorForm({ index, creditor, onRemove, onMoveDown, onMoveUp, onAdd }) {
  return (
    <table>
      <thead>
        <tr>
          <td colSpan="2">
            3.{index + 1}{' '}
            {onAdd && (
              <div className="btn btn-success btn-sm" onClick={onAdd} title="Add new creditor">
                +
              </div>
            )}
            {onMoveUp && (
              <div className="btn btn-primary btn-sm" onClick={onMoveUp} title={`Swap this creditor with 2.${index}`}>
                ▲
              </div>
            )}
            {onMoveDown && (
              <div
                className="btn btn-primary btn-sm"
                onClick={onMoveDown}
                title={`Swap this creditor with 2.${index + 2}`}
              >
                ▼
              </div>
            )}
            <div className="btn btn-danger btn-sm" onClick={onRemove} title="Remove creditor">
              X
            </div>
          </td>
          <td className="total-claim">
            <label>
              <span className="label">Amount of claim</span>
            </label>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowSpan="2">
            <div className="form-item">
              <label>
                <span className="label">Nonpriority creditor's name and mailing address</span>
              </label>

              <label>
                <span className="label">Name</span>
              </label>
              <Field name={`${creditor}.creditor_name`} component={InputField} placeholder="Name" />

              <label>
                <span className="label">Street</span>
              </label>
              <Field name={`${creditor}.creditor_address_street`} component={InputField} placeholder="Street" />

              <label>
                <span className="label">City</span>
              </label>
              <Field name={`${creditor}.creditor_address_city`} component={InputField} placeholder="City" />

              <label>
                <span className="label">State</span>
              </label>
              <Field name={`${creditor}.creditor_address_state`} component={InputField} placeholder="State" />

              <label>
                <span className="label">Zip Code</span>
              </label>
              <Field name={`${creditor}.creditor_address_zip_code`} component={InputField} placeholder="Zip Code" />

              <label>
                <span className="label">Country</span>
              </label>
              <Field name={`${creditor}.creditor_address_country`} component={InputField} placeholder="Country" />
            </div>
          </td>
          <td>
            <div className="form-item">
              <label>
                <span className="label">As of petition filing date, the claim is:</span>
                <span className="schedule-tips">Check all that apply.</span>
              </label>
              <label>
                <Field
                  name={`${creditor}.is_contingent`}
                  component={CheckboxField}
                  type="checkbox"
                  title="Contingent"
                />{' '}
                <Field
                  name={`${creditor}.is_unliquidated`}
                  component={CheckboxField}
                  type="checkbox"
                  title="Unliquidated"
                />{' '}
                <Field name={`${creditor}.is_disputed`} component={CheckboxField} type="checkbox" title="Disputed" />{' '}
              </label>
            </div>
          </td>
          <td className="money">
            <Field name={`${creditor}.total_claim`} component={DollarField} type="text" size="10" />
          </td>
        </tr>
        <tr>
          <td>
            <div className="form-item">
              <label>
                <span className="label">Basis for the claim</span>
              </label>
              <Field
                name={`${creditor}.claim_basis`}
                component={InputField}
                componentClass="textarea"
                rows="3"
                cols="30"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="form-item">
              <label>
                <span className="label">Date or dates debt was incurred</span>
              </label>
              <Field name={`${creditor}.debt_date`} component={InputField} type="text" placeholder="" />
            </div>
          </td>

          <td>
            <div className="form-item">
              <label>
                <span className="label">Is the claim subject to offset?</span>
              </label>
              <Field name={`${creditor}.is_subject_to_offset`} component={InputField} componentClass="select">
                <option value={false}>No</option>
                <option value>Yes</option>
              </Field>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="form-item no-num-range">
              <label>
                <span className="label">Last 4 digits of account number</span>
              </label>
              <Field name={`${creditor}.account_number_last_4_digits`} component={InputField} type="text" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_ef/ScheduleEFNonPriorityCreditorForm.jsx